// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartYAxisMetrics.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';
import { observer } from 'mobx-react';

import Metrics from 'share/components/controls/Izenda.Metrics';
import ChartYAxisMetricItem from './Izenda.ChartYAxisMetricItem';
import { isEmpty, pick, find, assign } from 'lodash/fp';

const MAXIMUM_METRICS = 5;

@observer
export default class ChartYAxisMetrics extends Component {
  constructor(props) {
    super(props);

    const reportPart = props.reportPart;
    const container = reportPart.reportPartContent && reportPart.reportPartContent.values;

    const dataSource = [];
    container.elements.forEach(field => {
      dataSource.push(field);
    });

    this.state = {
      dataSource: isEmpty(dataSource) ? [{}] : dataSource
    };
  }

  render() {
    const state = this.state || {};
    const props = this.props;
    const type = props.type;
    const reportPart = props.reportPart;
    let itemProps = pick(['reportPart', 'store'], props);
    const container = reportPart.reportPartContent && reportPart.reportPartContent.values;

    Object.assign(itemProps, {
      onDeleteElement: handleDeleteElement,
      onAddElement: handleAddElement,
      onUpdateElement: handleUpdateElement,
      type,
      canDelete: state.dataSource.length > 1
    });

    return (
      <Metrics
        maximumMetrics={MAXIMUM_METRICS}
        dataSource={this.state.dataSource}
        onAddMetric={addYAxisItem.bind(this)}
        onDeleteMetric={deleteYAxisItem.bind(this)}
        itemComponent={ChartYAxisMetricItem}
        {...itemProps}
      />
    );

    function handleDeleteElement(index, deleteElementId) {
      const deletedElement = find({ fieldId: deleteElementId }, container.elements);

      reportPart.removeFieldFromContainer(container, deletedElement);
      state.dataSource[index] = {};
    }

    function handleAddElement(newElement, index) {
      const dataSource = state.dataSource;
      // the newElement is created by virtual container so it's position is always 1, update it to the right position
      newElement.position = index + 1;
      if (index === dataSource.length - 1) {
        // insert field at the end of array
        return reportPart.commonInsertField(newElement.fieldName, newElement, container).then(updateDataSource);
      } else {
        // insert field in the middle
        return reportPart
          .commonInsertField(newElement.fieldName, newElement, container, index + 1)
          .then(updateDataSource);
      }

      function updateDataSource(element) {
        dataSource[index] = element;
        return element;
      }
    }

    function handleUpdateElement(element, index) {
      container.elements[index] = element;
    }

    function addYAxisItem() {
      this.state.dataSource.push({});
      this.setState({
        dataSource: this.state.dataSource
      });
    }

    function deleteYAxisItem(index) {
      index < container.elements.length && reportPart.removeFieldFromContainer(container, container.elements[index]);
      this.state.dataSource.splice(index, 1);
      this.setState({
        dataSource: this.state.dataSource
      });
    }
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/FieldContainers/Izenda.ChartYAxisMetrics.js